import { Input, Text, VStack } from '@chakra-ui/react';
import { UseNoteInputReturn } from '@diamond/sol-buyer/utils';

interface NoteFieldProps {
  inputProps: UseNoteInputReturn['inputProps'];
  charCount: number;
  maxLength: number;
}

export const NoteField = ({
  inputProps,
  charCount,
  maxLength,
}: NoteFieldProps) => {
  return (
    <VStack width="100%" maxWidth="100%" spacing={1} alignItems="stretch">
      <Input
        {...inputProps}
        borderRadius="md"
        borderWidth="1px"
        borderColor="gray.33"
        height="2rem"
        placeholder="Masukkan catatan produk di sini"
        fontSize={{ base: '12px', md: '12px' }}
        px="2"
        width="100%"
        maxWidth="100%"
        overflowX="auto"
        overflowY="hidden"
      />
      <Text alignSelf="end" fontSize="xs" textColor="gray.33" flexShrink={0}>
        {charCount}/{maxLength}
      </Text>
    </VStack>
  );
};
